import { isEqual, isAfter, endOfDay } from 'date-fns';

class ChildMembershipSerializer {
  constructor({
    parent_membership,
    start,
    end,
    consumed,
    parent_courses,
    id,
    balance,
    wait_consumed
  }) {
    this.id = id;
    this.name = parent_membership.name;
    this.start = start;
    this.end = end;
    this.consumed = consumed + wait_consumed;
    this.parent_courses = parent_courses;
    const dateExpired =
      !isEqual(endOfDay(end), endOfDay(new Date())) &&
      !isAfter(endOfDay(end), endOfDay(new Date()));
    const consumedExpired = consumed === balance;
    this.isExpired = consumedExpired || dateExpired;
  }
}

const HasSameEndMemebershipChecker = instance => {
  const {
    id: latest_membership_Id,
    end: latest_membership_End
  } = instance.latest_membership;

  const result = {
    isSameEndDayMembership: false,
    sameEndDayMemberships: []
  };
  for (let childmembership of instance.child_memberships) {
    if (
      childmembership.id !== latest_membership_Id &&
      childmembership.end === latest_membership_End
    ) {
      result.sameEndDayMemberships.push(
        new ChildMembershipSerializer(childmembership)
      );
    }
  }

  if (result.sameEndDayMemberships.length) {
    result.isSameEndDayMembership = true;
  }
  return result;
};

const SameEndMembershipSerializer = async data => {
  const targetSerializerCnt = data.length;
  let cnt = 0;
  for (let membership of data) {
    const {
      isSameEndDayMembership,
      sameEndDayMemberships
    } = await HasSameEndMemebershipChecker(membership);
    membership.isSameEndDayMembership = isSameEndDayMembership;
    membership.sameEndDayMemberships = sameEndDayMemberships;
    membership.isExpandOpen = !isSameEndDayMembership ? true : false;
    cnt++;
  }
  if (targetSerializerCnt === cnt) {
    return data;
  }
};

const ExpiredMembershipFilter = async data => {
  for (let membership of data) {
    let { isSameEndDayMembership, sameEndDayMemberships } = await membership;
    if (!isSameEndDayMembership) {
      continue;
    } else {
      membership.sameEndDayMemberships = sameEndDayMemberships.filter(
        membership => !membership.isExpired
      );
      if (!membership.sameEndDayMemberships.length) {
        membership.isExpandOpen = true;
        membership.isSameEndDayMembership = false;
      }
    }
  }
};

export { SameEndMembershipSerializer, ExpiredMembershipFilter };
